export const staircaseConfig = {
    gameSlug: 'juggle-factor',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 1500,
    minValue: 600,
    maxValue: 2400,
    stepSizesByPhase: [200, 100, 50, 25],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 36,
    direction: 'down-easier',
};
export const LETTERS = [
    'B',
    'D',
    'F',
    'H',
    'K',
    'L',
    'M',
    'P',
    'R',
    'T',
];
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            nBack: 1,
            targetRatio: 0.3,
            label: '1-back',
        };
    }
    if (level <= 20) {
        return {
            level,
            nBack: 2,
            targetRatio: 0.3,
            label: '2-back',
        };
    }
    if (level <= 30) {
        return {
            level,
            nBack: 3,
            targetRatio: 0.3,
            label: '3-back',
        };
    }
    if (level <= 40) {
        return {
            level,
            nBack: 3,
            targetRatio: 0.35,
            label: '3-back densifié',
        };
    }
    return {
        level,
        nBack: 4,
        targetRatio: 0.35,
        label: '4-back expert',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 400,
    feedbackMs: 200,
    itiMs: 500,
    /** Fenêtre de réponse maximale après que le stimulus a disparu. */
    responseWindowMs: 1800,
};
export const paradigmMeta = {
    slug: 'juggle-factor',
    paradigm: 'N-back (Kirchner 1958)',
    /** Internal only — non affiché. */
    masterMage: 'Volta · Inori',
    category: 'foudre_logique',
    goal: 'Maintenir et mettre à jour la mémoire de travail : compare la lettre courante à celle d\'il y a N positions.',
};
//# sourceMappingURL=params.js.map